import React from 'react';
import LandingMediaKitProposal from '../TNOMediaKitProposal';

const LandingMediaKitFranquiciasEnVenezuela = (props) => (
  <LandingMediaKitProposal
    {...props}
    forcedSlug="franquiciasenvenezuela"
    staticOnly
  />
);

export default LandingMediaKitFranquiciasEnVenezuela;
